function isErrorWithMessage(error) {
    return (typeof error === 'object' &&
        error !== null &&
        'message' in error &&
        typeof error.message === 'string');
}
function toErrorWithMessage(maybeError) {
    if (isErrorWithMessage(maybeError))
        return maybeError;
    try {
        return new Error(JSON.stringify(maybeError));
    }
    catch {
        // fallback in case there's an error stringifying the maybeError
        // like with circular references for example.
        return new Error(String(maybeError));
    }
}
export const getErrorMessage = (error) => {
    return toErrorWithMessage(error).message;
};
/**
 * Indicates whether or not the given object is an Axios error.
 *
 * @param error The object to test
 * @returns True if the object is an Axios error, otherwise false.
 */
export function isAxiosError(error) {
    return error === null || error === void 0 ? void 0 : error.isAxiosError;
}
export const displayMessageFromError = (error) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (isAxiosError(error)) {
        return ((_o = (_j = (_f = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reason) !== null && _c !== void 0 ? _c : (_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.result) !== null && _f !== void 0 ? _f : (_h = (_g = error.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.message) !== null && _j !== void 0 ? _j : (_m = (_l = (_k = error.response) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.error) !== null && _o !== void 0 ? _o : error.message);
    }
    return getErrorMessage(error);
};
